define('home/utils/cardUtils',[
    'core/bus',
    'home/utils/navigationUtils',
    'home/utils/sidebarUtils',
], function (
    Bus,
    NavigationUtils,
    sidebarUtils
) {
    'use strict';

    Bus.on({
        'uiCallback:showProfile': function (username) {
            var userFragment = '/by/' + username + '/';
            if (sidebarUtils.isSidebar())
                window.open(userFragment);
            else
                NavigationUtils.navigate(userFragment, { trigger: true });
        },
    });
});

